var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.000121613 2.69711L4.30419 7.00031L0.000121989 11.3035L1.84896 13.1523L8.00012 7.00031L1.84896 0.848269L0.000121613 2.69711Z","fill":"#555555"}));
}

ChevronRightInline.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
